export default "__VITE_ASSET__BdfLaH7h__"